import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React from 'react';

const LineChart = ({title, xdata, ydata}) => {
  const options = {
    chart: {
      type: 'spline'
    },
    credits: {
      enabled: false,
    },
    title: {
      text: title,
      style: {
        fontWeight: '400',
        fontSize: '18px',
        fontFamily: 'Roboto',
        fontStyle: 'italic'
      },
      floating: false,
      margin: 15,
      align: "center",
      verticalAlign: "bottom"
    },
    tooltip: {
      formatter: function() {
        return '<b>' +  this.series.name + ': </b>' +  this.y;
      }
    },
    yAxis: {
      title: {
        text: ''
      }
    },

    xAxis: {
      categories: xdata,
      labels: {
        rotation: -45,
        
      }
    },
    legend: {
      layout: 'horizontal',
      align: 'center',
      verticalAlign: 'bottom'
    },
    series: ydata,
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default LineChart;
